/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["td[_ngcontent-%COMP%]{word-break:break-word}td[_ngcontent-%COMP%]   a[_ngcontent-%COMP%] + span[_ngcontent-%COMP%]{padding-left:.75em}"];
export { styles as styles };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/request-list/request-list.component.css.shim.ngstyle.js.pre-build-optimizer.js